
import CustomTable from '../../../../../components/table/CustomTable';
import DetailsTableApp from '../Functionality/DetailsTableApp';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DetailsTable = ({
                          setDetailsModal,
                          setItemSelected,
                          dateRange,
                          setFinesCount,
                          modified,
                          setModified
}) => {

    const {
        pagination,
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons
    } = DetailsTableApp({
            setDetailsModal,
            setItemSelected,
            dateRange,
            setFinesCount,
            modified,
            setModified
        });

    return (
        <>
            <CustomTable
                tableId={tableId}
                searchId={searchId}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                textNotInformation={"user_no_infractions_period"}
            />
            {pagination()}
        </>
    );
};

export default DetailsTable;
